import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  pale: {
    main: '#FCF4D9',
    contrastText: '#383838',
  },
  typography: {
    h6: {
      fontSize: 18,
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#F0F2FC"
        }
      }
    }
  }
});

export default theme;
